import React from 'react';
import { motion } from 'framer-motion';
import { COLORS, FONTS } from './theme';

const AUDIENCES = [
  {
    who: 'Kids',
    what: 'Stories',
    detail: 'Tales of the Tirthankaras that hold a mirror to their own world.',
  },
  {
    who: 'Teens',
    what: 'Debates',
    detail:
      'A skeptical teen goes toe-to-toe with a wise Guru. Real questions, honest answers.',
  },
  {
    who: 'You',
    what: 'Honestly?',
    detail: 'You’ll catch yourself listening too.',
  },
];

const EASE = [0.22, 0.61, 0.36, 1] as const;

const ForEveryone: React.FC = () => {
  return (
    <section className="py-[86px]">
      <div className="w-full max-w-[640px] md:max-w-[760px] mx-auto px-[26px] md:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '0px 0px -8% 0px' }}
          transition={{ duration: 1, ease: EASE }}
          className="font-bold text-center mb-11 leading-[1.15] [text-wrap:balance]"
          style={{
            fontFamily: FONTS.heading,
            color: COLORS.nearBlack,
            fontSize: 'clamp(30px, 8vw, 42px)',
          }}
        >
          One subscription. The whole family.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {AUDIENCES.map((a, i) => (
            <motion.div
              key={a.who}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '0px 0px -8% 0px' }}
              transition={{ duration: 1, delay: 0.1 + i * 0.12, ease: EASE }}
              whileHover={{
                y: -3,
                borderColor: COLORS.goldLeaf,
                boxShadow: '0 16px 36px -16px rgba(62,39,35,0.4)',
              }}
              className="rounded p-[26px_24px] md:p-[30px_26px]"
              style={{
                backgroundColor: 'rgba(214,196,158,0.55)',
                border: '1px solid rgba(168,137,62,0.4)',
              }}
            >
              <span
                className="text-xs font-bold uppercase tracking-[0.28em]"
                style={{ fontFamily: FONTS.body, color: COLORS.goldLeafDark }}
              >
                {a.who}
              </span>
              <h3
                className="text-[23px] font-bold mt-1.5 mb-2.5"
                style={{ fontFamily: FONTS.heading, color: COLORS.redInk }}
              >
                {a.what}
              </h3>
              <p
                className="text-[17px] [text-wrap:pretty]"
                style={{ fontFamily: FONTS.body, color: COLORS.brown }}
              >
                {a.detail}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ForEveryone;
